import { assertNever, toNumber, } from '@freelancer/datastore/core';
import { OnlineOfflineUserStatusValueApi } from './online-offline.backend';
import { OnlineOfflineUserStatusValue, } from './online-offline.model';
export function transformOnlineOfflineStatusType(status) {
    switch (status) {
        case OnlineOfflineUserStatusValueApi.ONLINE:
            return OnlineOfflineUserStatusValue.ONLINE;
        case OnlineOfflineUserStatusValueApi.OFFLINE:
            return OnlineOfflineUserStatusValue.OFFLINE;
        default:
            return assertNever(status);
    }
}
export function transformOnlineOfflineStatusFetch(_a) {
    var userId = _a[0], status = _a[1];
    return {
        id: toNumber(userId),
        status: transformOnlineOfflineStatusType(status),
    };
}
export function transformOnlineOfflineStatusChange(data) {
    return {
        id: data.user,
        status: transformOnlineOfflineStatusType(data.to),
    };
}
